module.exports = __webpack_public_path__ + "img/frente-dni-nuevo.2bd56161.png";